/* v71 (2026-05-08): batida-cake-configurator. Renders visual shape cards + filtered servings buttons for products with Kształt + Ilość porcji + Napis option structure. Layered on top of Pipeline's native radios (which we hide); click forwards to underlying radio so price/variant/sellout machinery keeps working. No-op for small cakes (existing v12 size cards path).

   v81b (2026-05-08): synchronous detection + body class so CSS can pre-hide Pipeline's native Kształt + Porcji wrappers immediately at parse time. Eliminates the ~500ms flash where natives showed before our build() callback fired after /products/<handle>.js resolved. If the fetch fails for any reason, we re-show the natives via the safety timer at line bottom — graceful degradation. */
(function(){
  if(window.__batidaCakeConfigLoaded)return;window.__batidaCakeConfigLoaded=true;

  var SHAPE_VOCAB={
    round:['okrągły','okragly','round','круглий','rond','rund'],
    rect: ['prostokątny','prostokatny','rectangular','прямокутний','rectangulaire','rechteckig']
  };
  var SHAPE_OPTION_KW=['kształt','ksztalt','shape','форма','forme','form'];
  var SERVINGS_OPTION_KW=['porcj','serving','порцій','portion','portionen'];

  function lc(s){return(s||'').toLowerCase();}
  function matchAny(v,list){var x=lc(v);for(var i=0;i<list.length;i++)if(x.indexOf(list[i])!==-1)return true;return false;}
  function shapeKindFor(v){if(matchAny(v,SHAPE_VOCAB.round))return'round';if(matchAny(v,SHAPE_VOCAB.rect))return'rect';return'other';}

  function findWrappers(){
    var ws=document.querySelectorAll('.selector-wrapper[data-select-label]');
    var shape=null,servings=null;
    for(var i=0;i<ws.length;i++){
      var lbl=ws[i].getAttribute('data-select-label');
      if(!shape&&matchAny(lbl,SHAPE_OPTION_KW))shape=ws[i];
      if(!servings&&matchAny(lbl,SERVINGS_OPTION_KW))servings=ws[i];
    }
    return shape&&servings?{shape:shape,servings:servings}:null;
  }

  /* v81b synchronous gate — runs at script parse time, before product fetch.
     Sets body class so CSS pre-hides natives. Always re-tries on retry timer
     in case Pipeline mounts the wrappers late. Fail-open: if findWrappers()
     never finds them, the body class never gets set, natives stay visible. */
  function markIfV71Product(){
    if(document.body.classList.contains('batida-v71-active'))return true;
    var det=findWrappers();
    if(det){document.body.classList.add('batida-v71-active');return true;}
    return false;
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',markIfV71Product);
  }else{
    markIfV71Product();
  }
  /* Retries — Pipeline section reload, Alpine variant picker mount race */
  [50,150,400,1000].forEach(function(ms){setTimeout(markIfV71Product,ms);});

  function getRadios(wrap){return wrap.querySelectorAll('input[type="radio"]');}
  function getSelectedValue(wrap){var rs=getRadios(wrap);for(var i=0;i<rs.length;i++)if(rs[i].checked)return rs[i].value;return null;}
  function clickRadio(wrap,value){var rs=getRadios(wrap);for(var i=0;i<rs.length;i++)if(rs[i].value===value){rs[i].click();return true;}return false;}

  /* 9.10 (Aleksandra): the cake diameter on the size buttons ("≈15 porcji" + "Ø 27 cm"), only for the round shape. The size values are
     shared by both shapes, so the diameter is looked up by shape + size in the data the theme prints
     (snippets/batida-v7-sizediam: variant field custom.srednica_cm; rectangular variants have none). No data = no second line. */
  function readSizeDiam(){
    var el=document.querySelector('script[data-batida-sizediam]');
    if(!el)return null;
    try{
      var j=JSON.parse(el.textContent||'{}'),map={},n=0;
      (j.d||[]).forEach(function(r){map[r[0]+'\u0001'+r[1]]=r[2];n++;});
      return n?map:null;
    }catch(e){return null;}
  }
  function diamText(map,shape,size){
    var cm=map&&map[shape+'\u0001'+size];
    return cm?'Ø '+cm+' cm':'';  /* like the facts tile / option labels: Ø and cm are the same in every language */
  }
  /* the "Ø N cm" line of every size button for the given shape (the round labels are filled in when the buttons are built) */
  function applyDiam(container,map,shape){
    if(!map)return;
    container.querySelectorAll('[data-batida-cake-serving]').forEach(function(b){
      var d=b.querySelector('.batida-cake-serving__d');
      if(d)d.textContent=diamText(map,shape,b.getAttribute('data-batida-cake-serving'));
    });
  }

  function fetchProductData(handle){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return fetch(root.replace(/\/$/, '')+'/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;});
  }

  function availableServingsForShape(pj,shape){
    if(!pj||!pj.variants)return null;
    var avail={};
    pj.variants.forEach(function(v){
      if(lc(v.option1)===lc(shape)&&v.available)avail[v.option2]=true;
    });
    return avail;
  }

  function shapeRange(pj,shape){
    var avail=availableServingsForShape(pj,shape);
    if(!avail)return'';
    var nums=Object.keys(avail).map(function(k){var m=k.match(/(\d+)/);return m?parseInt(m[1],10):null;}).filter(Boolean);
    if(!nums.length)return'';
    var min=Math.min.apply(null,nums),max=Math.max.apply(null,nums);
    /* v89 (2026-05-09): use locale template instead of hardcoded ' porcji'.
       Template `batida.cake_configurator.servings_range` = "{{ min }}–{{ max }} porcji"
       on PL master; T Lab translates per locale (e.g. EN "{{ min }}–{{ max }} servings"). */
    var t=(window.batidaT&&window.batidaT('cake_configurator.servings_range',min+'–'+max+' porcji'))||(min+'–'+max+' porcji');
    return t.replace('{{ min }}',min).replace('{{ max }}',max);
  }

  /* 6.10 (audit UX-03): min-max servings per shape from the variants; '' when nothing can be computed. */
  function footnoteText(pj,radios){
    var tpl=window.batidaT&&window.batidaT('cake_configurator.footnote_range','');
    if(!tpl||typeof tpl!=='string'||tpl.indexOf('{{ min }}')===-1)return'';
    var parts=[];
    for(var i=0;i<radios.length;i++){
      var avail=availableServingsForShape(pj,radios[i].value);
      if(!avail)continue;
      var nums=Object.keys(avail).map(function(k){var m=k.match(/(\d+)/);return m?parseInt(m[1],10):null;}).filter(Boolean);
      if(!nums.length)continue;
      parts.push(tpl.replace('{{ shape }}',radios[i].value).replace('{{ min }}',Math.min.apply(null,nums)).replace('{{ max }}',Math.max.apply(null,nums)));
    }
    return parts.length?parts.join('. ')+'.':'';
  }

  /* 29.09: Batida's own icons (snippets/batida-icons-js.liquid -> window.batidaIcon); the old drawings stay as the fallback */
  var BI=function(n,sz,old){return (window.batidaIcon&&window.batidaIcon(n,sz))||old;};
  var ICON_ROUND='<svg width="44" height="32" viewBox="0 0 60 44" fill="none" stroke="#424242" stroke-width="1.5"><ellipse cx="30" cy="34" rx="22" ry="6"/><path d="M8 34v-14c0-3.3 9.85-6 22-6s22 2.7 22 6v14"/><path d="M8 22c0 3.3 9.85 6 22 6s22-2.7 22-6"/></svg>';
  var ICON_RECT ='<svg width="44" height="32" viewBox="0 0 60 44" fill="none" stroke="#424242" stroke-width="1.5"><rect x="8" y="14" width="44" height="20" rx="2"/><line x1="8" y1="20" x2="52" y2="20"/></svg>';

  function buildShapeCard(value,range,kind,isActive){
    var btn=document.createElement('button');
    var ICON_ROUND_=BI('tort-okragly',40,ICON_ROUND),ICON_RECT_=BI('tort-prostokatny',40,ICON_RECT);
    btn.type='button';
    btn.className='batida-cake-shape'+(isActive?' batida-cake-shape--active':'');
    btn.setAttribute('data-batida-cake-shape',value);
    btn.setAttribute('aria-pressed',isActive?'true':'false');
    var icon=kind==='round'?ICON_ROUND_:(kind==='rect'?ICON_RECT_:'');
    btn.innerHTML='<div class="batida-cake-shape__icon">'+icon+'</div>'+
                  '<div class="batida-cake-shape__label">'+value+'</div>'+
                  '<div class="batida-cake-shape__range">'+range+'</div>';
    return btn;
  }

  function buildServingBtn(value,isActive,diam){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='batida-cake-serving'+(isActive?' batida-cake-serving--active':'');
    btn.setAttribute('data-batida-cake-serving',value);
    btn.setAttribute('aria-pressed',isActive?'true':'false');
    if(diam===undefined){btn.textContent=value;return btn;}
    /* 9.10: with diameter data the button is two lines: the size value + the (round only) "Ø N cm" */
    var v=document.createElement('span');v.className='batida-cake-serving__v';v.textContent=value;btn.appendChild(v);
    var d=document.createElement('span');d.className='batida-cake-serving__d';d.textContent=diam;btn.appendChild(d);
    return btn;
  }

  /* 6.10 (audit A11Y-01): the chosen shape / serving is also exposed as aria-pressed (it was only the --active CSS class). */
  function syncPressed(container){
    container.querySelectorAll('[data-batida-cake-shape],[data-batida-cake-serving]').forEach(function(b){
      b.setAttribute('aria-pressed',b.classList.contains('batida-cake-shape--active')||b.classList.contains('batida-cake-serving--active')?'true':'false');
    });
  }

  function applyFilter(container,pj,shapeValue){
    var avail=availableServingsForShape(pj,shapeValue);
    if(!avail)return;
    container.querySelectorAll('[data-batida-cake-serving]').forEach(function(b){
      b.style.display=avail[b.getAttribute('data-batida-cake-serving')]?'':'none';
    });
  }

  function build(det,pj){
    if(det.shape.getAttribute('data-batida-cake-config')==='1')return;
    det.shape.setAttribute('data-batida-cake-config','1');

    /* Hide native pickers — we keep them in DOM for variant binding, just visually invisible. */
    det.shape.style.display='none';
    det.servings.style.display='none';

    var container=document.createElement('div');
    container.className='batida-cake-configurator';

    /* Shape section */
    var shapeSection=document.createElement('div');
    shapeSection.className='batida-cake-section';
    var sLabel=document.createElement('p');
    sLabel.className='batida-cake-section__label';
    sLabel.textContent=det.shape.getAttribute('data-select-label');
    shapeSection.appendChild(sLabel);

    var sGrid=document.createElement('div');
    sGrid.className='batida-cake-shape-grid';
    sGrid.setAttribute('role','group');
    sGrid.setAttribute('aria-label',det.shape.getAttribute('data-select-label')||'');
    var sRadios=getRadios(det.shape);
    var roundRadio=null;
    for(var i=0;i<sRadios.length;i++){
      var v=sRadios[i].value;
      var kind=shapeKindFor(v);
      sGrid.appendChild(buildShapeCard(v,shapeRange(pj,v),kind,sRadios[i].checked));
      if(kind==='round'&&!roundRadio)roundRadio=sRadios[i];
    }
    shapeSection.appendChild(sGrid);
    container.appendChild(shapeSection);

    /* Servings section */
    var servSection=document.createElement('div');
    servSection.className='batida-cake-section';
    var pLabel=document.createElement('p');
    pLabel.className='batida-cake-section__label';
    pLabel.textContent=det.servings.getAttribute('data-select-label');
    servSection.appendChild(pLabel);

    var pGrid=document.createElement('div');
    pGrid.className='batida-cake-serving-grid';
    pGrid.setAttribute('role','group');
    pGrid.setAttribute('aria-label',det.servings.getAttribute('data-select-label')||'');
    var pRadios=getRadios(det.servings);
    var diamMap=readSizeDiam(),curShape0=getSelectedValue(det.shape);
    if(diamMap)pGrid.classList.add('batida-cake-serving-grid--sd');
    for(var j=0;j<pRadios.length;j++){
      pGrid.appendChild(buildServingBtn(pRadios[j].value,pRadios[j].checked,diamMap?diamText(diamMap,curShape0,pRadios[j].value):undefined));
    }
    servSection.appendChild(pGrid);

    /* 6.10 (audit UX-03, Aleksandra): the footnote lists the product's real range per shape ("Okrągły: około 8-30 porcji.
       Prostokątny: około 15-30 porcji."), built from the variants this script already has; locale key
       batida.cake_configurator.footnote_range (bridge: snippets/batida-locale-bridge.liquid). The old "larger sizes only in
       rectangular" sentence was wrong whenever the round shape has the largest size too. No range computable = no footnote. */
    var footText=footnoteText(pj,sRadios);
    if(footText){
    var foot=document.createElement('p');
    foot.className='batida-cake-footnote';
    foot.textContent=footText;
    /* 29.09: batida.pl (html.v7) only - the info circle as a Batida icon before the text; assets/batida-b2c.css turns the old CSS ::before icon off there. b2b keeps its CSS icon. */
    var footIc=document.documentElement.classList.contains('v7')?BI('info',16,''):'';if(footIc){foot.insertAdjacentHTML('afterbegin',footIc);}
    servSection.appendChild(foot);
    }
    container.appendChild(servSection);

    det.shape.parentNode.insertBefore(container,det.shape);

    /* Click delegation */
    container.addEventListener('click',function(e){
      var sBtn=e.target.closest('[data-batida-cake-shape]');
      var pBtn=e.target.closest('[data-batida-cake-serving]');
      if(sBtn){
        e.preventDefault();
        var v=sBtn.getAttribute('data-batida-cake-shape');
        clickRadio(det.shape,v);
        container.querySelectorAll('[data-batida-cake-shape]').forEach(function(b){b.classList.toggle('batida-cake-shape--active',b===sBtn);});
        applyFilter(container,pj,v);
        applyDiam(container,diamMap,v);
        /* If currently selected serving is now unavailable, pick first available */
        var avail=availableServingsForShape(pj,v);
        if(avail){
          var curServ=getSelectedValue(det.servings);
          if(!avail[curServ]){
            var firstAvail=Object.keys(avail)[0];
            if(firstAvail){
              clickRadio(det.servings,firstAvail);
              container.querySelectorAll('[data-batida-cake-serving]').forEach(function(b){b.classList.toggle('batida-cake-serving--active',b.getAttribute('data-batida-cake-serving')===firstAvail);});
            }
          }
        }
      }else if(pBtn){
        e.preventDefault();
        var sv=pBtn.getAttribute('data-batida-cake-serving');
        clickRadio(det.servings,sv);
        container.querySelectorAll('[data-batida-cake-serving]').forEach(function(b){b.classList.toggle('batida-cake-serving--active',b===pBtn);});
      }
      syncPressed(container);
    });

    /* Preselect Round if not already selected */
    if(roundRadio&&!roundRadio.checked){
      roundRadio.click();
      var roundCard=container.querySelector('[data-batida-cake-shape="'+roundRadio.value+'"]');
      if(roundCard){
        container.querySelectorAll('[data-batida-cake-shape]').forEach(function(b){b.classList.toggle('batida-cake-shape--active',b===roundCard);});
      }
    }

    /* Initial filter */
    var curShape=getSelectedValue(det.shape);
    if(curShape){applyFilter(container,pj,curShape);applyDiam(container,diamMap,curShape);}
    syncPressed(container);
    /* the native radios can change without a click on our buttons (variant picker, URL): keep the exposed state true */
    [det.shape,det.servings].forEach(function(w){w.addEventListener('change',function(){
      var cs=getSelectedValue(det.shape),cv=getSelectedValue(det.servings);
      applyDiam(container,diamMap,cs);
      container.querySelectorAll('[data-batida-cake-shape]').forEach(function(b){b.classList.toggle('batida-cake-shape--active',b.getAttribute('data-batida-cake-shape')===cs);});
      container.querySelectorAll('[data-batida-cake-serving]').forEach(function(b){b.classList.toggle('batida-cake-serving--active',b.getAttribute('data-batida-cake-serving')===cv);});
      syncPressed(container);
    });});
  }

  function init(){
    var det=findWrappers();
    if(!det)return;
    /* Sync mark — repeats markIfV71Product's effect to be safe. */
    document.body.classList.add('batida-v71-active');
    var stubEl=document.querySelector('[data-product-json]');
    var stub=null;
    if(stubEl){try{stub=JSON.parse(stubEl.textContent||stubEl.innerHTML);}catch(e){}}
    if(stub&&stub.variants&&stub.variants.length){
      build(det,stub);
    }else if(stub&&stub.handle){
      fetchProductData(stub.handle).then(function(pj){if(pj)build(det,pj);}).catch(function(){
        /* Safety: if fetch fails the natives are still hidden behind body.batida-v71-active.
           Un-mark so the user gets a working (if unstyled) picker rather than nothing. */
        document.body.classList.remove('batida-v71-active');
      });
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  /* Retry a few times in case Pipeline initializes the variant picker after our init runs. */
  [400,1200,3000].forEach(function(ms){setTimeout(init,ms);});

  /* Final safety net: if 6s after load the body still has batida-v71-active but
     no .batida-cake-configurator was built (e.g. fetch hung, JS error in build),
     un-mark so the user can interact with Pipeline's natives. */
  setTimeout(function(){
    if(document.body.classList.contains('batida-v71-active')&&!document.querySelector('.batida-cake-configurator')){
      document.body.classList.remove('batida-v71-active');
    }
  },6000);
})();
